module.exports = __webpack_public_path__ + "static/media/dollor_label_vector.6db862db.svg";